import { create } from "zustand";
import { IDashboardSteps, INav } from "@/types/nav.types";
import { createJSONStorage, persist } from "zustand/middleware";

export const useNav = create<INav>((set) => ({
  isShow: "open",
  setIsShow: (val) =>
    set({
      isShow: val,
    }),
}));

export const useDashboardSteps = create(
  persist<IDashboardSteps>(
    (set) => ({
      type: "select",
      setType: (val) =>
        set({
          type: val,
        }),
    }),
    {
      name: "dashboardSteps",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
